import moment from '@/common/modules/moment-fallback';

export function tommyDate(date: Date): string {
    return moment(date).format('YYYY-MM-DD');
}
